import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';
import { AuthService } from 'src/shared/services/auth.service';
import { ResponseService } from 'src/shared/services/response-service.service';
import { SchoolProgramService } from 'src/shared/services/school-program.service';
import { TranslateService } from 'src/shared/services/translate.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-activity-approver',
  templateUrl: './activity-approver.component.html',
  styleUrls: ['./activity-approver.component.scss']
})
export class ActivityApproverComponent implements OnInit {

  paramForm: FormGroup;
  data: any[] = [];
  columnsToDisplay = ['school_program_name','school_program_category_name','activity_name'];
  sort = 'asc';
  orderBy = 'activity_name';
  subscription: Subscription;
  loading = false;
  searchParam: string;
  periodSelected: any;
  periodList: any;

  constructor(
    private spService: SchoolProgramService,
    private translate: TranslateService,
    private rpSer: ResponseService,
    public auth: AuthService
  ) { }

  ngOnInit(): void {
    this.auth.loadPermissions(true);
    if (this.auth.permissions['SCHOOL_PROGRAM_ACTIVITY_APPROVER_APPROVE'] || this.auth.permissions['SCHOOL_PROGRAM_ACTIVITY_APPROVER_REJECT']) {
      this.columnsToDisplay.push('action');
    }
    this.translate.load('extracurricular', 'activity');
    this.initForm();
  }

  initForm() {
    this.paramForm = new FormGroup({
      'academic_year': new FormControl(null),
      'school_location_id': new FormControl(null),
      'school_level_id': new FormControl(null),
      'school_program_id': new FormControl(null),
      'school_program_category_id': new FormControl(null),
      'school_program_activity_id': new FormControl(null),
      'year_level_id': new FormControl(null),
      'period_id': new FormControl(null)
    });
  }

  onChangeAcademicYear(item: any) {

    this.paramForm.controls['academic_year'].markAsTouched();
    this.paramForm.controls['academic_year'].setValue(item ? item.academic_year : null);

    this.paramForm.controls['school_location_id'].setValue(null);

    this.getActivityData();

  }

  onChangeSchoolLevel(item: any) {

    this.paramForm.controls['school_location_id'].markAsTouched();
    this.paramForm.controls['school_location_id'].setValue(item ? item.school_location_id : null);

    this.paramForm.controls['school_level_id'].markAsTouched();
    this.paramForm.controls['school_level_id'].setValue(item ? item.school_level_id : null);

    this.paramForm.controls['year_level_id'].setValue(null);

    this.getActivityData();

  }

  onChangeSchoolProgram(item: any) {

    this.paramForm.controls['school_program_id'].markAsTouched();
    this.paramForm.controls['school_program_id'].setValue(item ? item.school_program_id : null);

    this.paramForm.controls['school_program_category_id'].setValue(null);

    this.getActivityData();

  }

  onChangeSchoolProgramCategory(item: any) {

    this.paramForm.controls['school_program_category_id'].markAsTouched();
    this.paramForm.controls['school_program_category_id'].setValue(item ? item.school_program_category_id : null);
    this.getActivityData();

  }

  onSort(order: string) {
    this.sort = this.sort == 'asc' ? 'desc' : 'asc';
    this.orderBy = order;
    this.getActivityData();
  }

  getActivityData() {
    this.loading= true;
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.data = [];
    const params = {
      academic_year: this.paramForm.get('academic_year')?.value,
      school_locaiton_id: this.paramForm.get('school_location_id')?.value,
      school_program_id: this.paramForm.get('school_program_id')?.value,
      school_program_category_id: this.paramForm.get('school_program_category_id')?.value,
      sort: this.sort,
      orderBy: this.orderBy,
      search: this.searchParam,
      approved: 'waiting'
    }
    this.subscription = this.spService.getSchoolProgramActivity(params).subscribe({
      next: (response: any) => {
        if (response.status) {
          this.data = response.data;
          this.loading = false;
        } else {
          this.rpSer.showAddError(response.message ? response.message : 'An unexpected error occurred. Please check your connection and try again.');
          this.loading = false;
        }
      },
      error: (error: any) => {
        this.rpSer.showAddError();
        this.loading = false;
      }
    });
  }

  saveApprove(data: any, isApprove: boolean) {
    Swal.fire({
      title: "Are you sure to approve this activity?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes"
    }).then((result) => {
      if (result.isConfirmed) {
        data.approved = isApprove;
        const params = {
          school_program_activity_id: data.school_program_activity_id,
          approved: isApprove,
          school_location_id: data.school_location_id,
          year_level_id: data.year_level_id,
          academic_year: this.paramForm.get('academic_year')?.value,
        }
        this.spService.approveSchoolProgramActivity(params).subscribe({
          next: (response: any) => {
            if(response.status){
              this.rpSer.showAddSuccess("Activity has been approved.");
              this.getActivityData();
            } else {
              this.rpSer.showAddError(response.message ? response.message : 'An unexpected error occurred. Please check your connection and try again.'); 
            }
          },
          error: (error: any) => {
            this.rpSer.showAddError();
          }
        });
      }
    });
  }


}
